import { useSnackbar } from 'notistack'
import React, { useContext, useEffect, useRef } from 'react'

import { ToastContext } from '../lib/toasts/context'

export const HideAllToasts: React.FC = () => {
  const { toasts, hideToast } = useContext(ToastContext)
  const toastsToHide = useRef(toasts)
  const { closeSnackbar } = useSnackbar()

  useEffect(() => {
    closeSnackbar()
    toastsToHide.current.forEach((toast) => {
      hideToast(toast)
    })
  }, [closeSnackbar, hideToast])

  return null
}
